import {
  FETCH_ACTIVE_PROFILES_COUNT,
  FETCH_ALL_LISTS,
  FETCH_LIST_PAGINATION_SUCCESS,
  FETCH_LISTS_FOR_DROPDOWNS,
  FETCH_LISTS_REQUEST,
  FETCH_LISTS_SUCCESS,
  FETCH_LISTS_WITH_ACTIVE_PROFILES,
  LIST_ENRICHMENT_FINISHED,
  LIST_ENRICHMENT_STARTED,
} from './listTypes';

const initialState = {
  allLists: [],
  dropdownLists: [],
  list: {},
  listPageCount: {},
  isLoading: true,
  listEnrichmentStartedIds: [],
  listsWithActiveProfiles: [],
  activeCount: 0,
};

const listReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LISTS_REQUEST:
      return { ...state, isLoading: true };
    case FETCH_LIST_PAGINATION_SUCCESS: {
      const body = {
        ...state,
        isLoading: false,
        list: {},
        listPageCount: {},
      };
      if (!action.payload.evict) {
        body.list = { ...state.list };
        body.listPageCount = { ...state.listPageCount };
      }

      body.list = { ...body.list, [action.payload.key]: action.payload.data };
      body.listPageCount = { ...body.listPageCount, [action.payload.key]: action.payload.count };

      return body;
    }
    case FETCH_ALL_LISTS:
      return {
        ...state,
        allLists: action.payload,
      };

    case FETCH_LISTS_FOR_DROPDOWNS: {
      return {
        ...state,
        dropdownLists: action.payload,
      };
    }
    case FETCH_LISTS_WITH_ACTIVE_PROFILES: {
      return {
        ...state,
        listsWithActiveProfiles: action.payload,
      };
    }
    case FETCH_ACTIVE_PROFILES_COUNT: {
      return {
        ...state,
        activeCount: action.payload,
      };
    }
    case LIST_ENRICHMENT_STARTED:
      return {
        ...state,
        listEnrichmentStartedIds: Array.from(new Set([...state.listEnrichmentStartedIds, action.payload])),
      };
    case LIST_ENRICHMENT_FINISHED:
      return {
        ...state,
        listEnrichmentStartedIds: state.listEnrichmentStartedIds.filter((id) => id !== action.payload),
      };
    default:
      return { ...state };
  }
};

export default listReducer;
